import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WidgetWrapper } from '@/src/components/projects/ProjectDashboard/WidgetWrapper.jsx';
import { WidgetInner } from '@/src/components/projects/ProjectDashboard/WidgetInner.jsx';
import { getOrgTermsContent } from '@/src/content/utils.js';
import { WidgetCard } from '@/src/components/projects/ProjectDashboard/WidgetCard.jsx';
import { ReadinessIcon } from '@/src/components/icons/ReadinessIcon.jsx';
import { CommunicationIcon } from '@/src/components/icons/CommunicationIcon.jsx';
import { TrainingIcon } from '@/src/components/icons/TrainingIcon.jsx';
import { SustainmentIcon } from '@/src/components/icons/SustainmentIcon.jsx';
import ProgressBar from '@/src/components/ProgressBar.jsx';
import Empty from '@/src/components/Empty.jsx';
import { initiativesWidgetContent } from '@/src/components/EmptyStates.jsx';
import { INITIATIVE_TYPES } from '@/src/lib/schema.js';
import { buildPath } from '@/src/components/Link.jsx';
import { PROJECTS_INITIATIVES } from '@/src/constants/routes.js';

const INITIATIVE_CONFIG = {
  communication: { Icon: CommunicationIcon, label: 'Communication' },
  readiness: { Icon: ReadinessIcon, label: 'Readiness' },
  training: { Icon: TrainingIcon, label: 'Training' },
  sustainment: { Icon: SustainmentIcon, label: 'Sustainment' },
};

export const InitiativesWidget = ({ data }) => {
  const { total } = data;
  const navigate = useNavigate();
  const { slug, projectId } = useParams();

  const handleNavigateToInitiatives = () => {
    const path = buildPath(PROJECTS_INITIATIVES, { slug, projectId });
    navigate(path);
  };

  return (
    <WidgetWrapper className="initiatives-widget">
      <div className="flex align-center m-b-12">
        <h2>Change {getOrgTermsContent('initiatives')} Overview</h2>
        <strong className="header-item bordered component-bg-white text-primary">
          <span className="text-muted">Total: </span>
          <span>{total}</span>
        </strong>
      </div>
      {total ? (
        <WidgetInner height={400}>
          <div className="widget-grid">
            {INITIATIVE_TYPES.map((type) => {
              const { Icon, label } = INITIATIVE_CONFIG[type];
              const { count, total: typeTotal, percentage } = data[type];
              return (
                <WidgetCard
                  key={type}
                  sentiment={type}
                  className="flex-col p-y-24 p-x-20"
                >
                  <div className="flex m-b-24">
                    <div
                      className={`initiative-type-icon initiative-type-icon-${type}`}
                    >
                      <Icon />
                    </div>
                    <h3 className="m-l-20">{label}</h3>
                  </div>
                  <div className="m-b-6 font-semibold">
                    {percentage}% ({count}/{typeTotal})
                  </div>
                  <ProgressBar
                    count={count}
                    total={typeTotal}
                    sentiment={type}
                  />
                </WidgetCard>
              );
            })}
          </div>
        </WidgetInner>
      ) : (
        <WidgetInner height={400} className="flex flex-col">
          <Empty
            simplified
            content={initiativesWidgetContent}
            actionAuthorization={{
              action: 'read',
              subject: 'project',
            }}
            action={handleNavigateToInitiatives}
          />
        </WidgetInner>
      )}
    </WidgetWrapper>
  );
};
